import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  GeckoModal,
  GeckoFields,
  GECKO_CONSTS,
  GeckoToastService,
  GeckoLoadingService,
  GeckoModalService,
} from 'ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import ReplyBox from '../ReplyBox';
import { RBfuncs } from '../ReplyBox/ReplyBoxFuncs';
import { CONSTS } from 'constants/index.js';
import {
  convertToRaw,
  EditorState,
  ContentState,
  convertFromRaw,
} from 'draft-js';
import AgentTeamSelect from 'components/AgentTeamSelect';
import {
  buildContactGroup,
  buildAgentGroup,
  buildSelectedChannelGroup,
} from 'services/template-tags';
import { OptionDisplay } from './OptionDisplay';
import { ValueDisplay } from './ValueDisplay';
import { validateEmailOption, validateTelephoneOption, dedupe } from './utils';
import { channelsForUsersTeams } from 'services/team-filtering';

import './index.scss';

export class ComposeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {
        to: props.sendTo || [],
        assign_to: [`agent_${props.myId}`],
        channel: props.channel || undefined,
        messageEditorState: EditorState.createEmpty(),
        transcriptEditorState: EditorState.createEmpty(),
      },
      toOptions: [],
      contacts: [],
      channelOptions: [],
      loadingContacts: false,
      excludeSignature: false,
    };
    this.updateMessageCallbacks = {
      editorState: (messageEditorState) => {
        const values = { ...this.state.values, messageEditorState };
        return this.setState({ values });
      },
      attachments: (attachments) => {
        const newState = { ...this.state };
        newState.values.attachments = attachments;
        return this.setState(newState);
      },
    };
    this.updateTranscriptCallbacks = {
      editorState: (transcriptEditorState) => {
        const values = { ...this.state.values, transcriptEditorState };
        return this.setState({ values });
      },
      attachments: (attachments) => {
        const newState = { ...this.state };
        newState.values.attachments = attachments;
        return this.setState(newState);
      },
    };
  }

  UNSAFE_componentWillMount() {
    let values = this.state.values;

    if (this.props.message) {
      if (typeof this.props.message === 'string') {
        const message = EditorState.createWithContent(
          ContentState.createFromText(this.props.message)
        );
        values = Object.assign({}, values, { messageEditorState: message });
        this.setState({ defaultMessageEditorState: message });
      } else {
        const message = EditorState.createWithContent(
          convertFromRaw(this.props.message)
        );
        values = Object.assign({}, values, { messageEditorState: message });
        this.setState({ defaultMessageEditorState: message });
      }
    }
    if (this.props.transcript) {
      if (typeof this.props.transcript == 'string') {
        const transcript = EditorState.createWithContent(
          ContentState.createFromText(this.props.transcript)
        );
        values = Object.assign({}, values, {
          transcriptEditorState: transcript,
        });
        this.setState({ defaultTranscriptEditorState: transcript });
      } else {
        const transcript = EditorState.createWithContent(
          convertFromRaw(this.props.transcript)
        );
        values = Object.assign({}, values, {
          transcriptEditorState: transcript,
        });
        this.setState({ defaultTranscriptEditorState: transcript });
      }
    }

    if (this.props.subject) {
      values = Object.assign({}, values, { subject: this.props.subject });
    }
    this.setState({ values });
  }

  componentDidMount() {
    if (!this.props.dontSelectExistingContacts) {
      this.setState({ loadingContacts: false });
    }
    this.setChannelOptions();
  }

  getContacts(params) {
    if (params.search !== undefined && params.search.length < 3)
      return Promise.resolve([]);
    if (this.props.contactOverride) {
      let contacts = [];
      if (this.props.contactOverride.email) {
        contacts.push({
          id: this.props.contactOverride.id,
          name: this.props.contactOverride.full_name,
          email: this.props.contactOverride.email,
          type: 'mailgun',
          label: `${this.props.contactOverride.full_name} ${this.props.contactOverride.email}`,
          value: `mailgun_${this.props.contactOverride.id}`,
        });
      }
      if (this.props.contactOverride.tel) {
        contacts.push({
          id: this.props.contactOverride.id,
          name: this.props.contactOverride.full_name,
          tel: this.props.contactOverride.tel,
          type: 'twilio',
          label: `${this.props.contactOverride.full_name} ${this.props.contactOverride.tel}`,
          value: `twilio_${this.props.contactOverride.id}`,
        });
      }
      return Promise.resolve(contacts);
    }
    return GeckoRequest.get('/contact/composable', params);
  }

  getPickedType() {
    if (this.props.messageType) {
      return this.props.messageType;
    }
    if (!this.state || !this.state.values.to || !this.state.values.to.length) {
      return null;
    }
    const to = this.state.values.to[0];
    // If it's an exisiting contact we can quickly grab the type from the value
    if (to.indexOf('mailgun') !== -1 || to.indexOf('twilio') !== -1) {
      return to.split('_')[0];
    }
    // If it passes the email validate function it must be an email
    if (validateEmailOption(to)) {
      return 'mailgun';
    }
    // If it passes the telephone validate function it must be a mobile number
    if (validateTelephoneOption(to)) {
      return 'twilio';
    }
  }

  getToOptions(contacts = this.state.toOptions) {
    const pickedType = this.getPickedType();
    if (!pickedType) {
      return contacts;
    }
    return contacts.filter((contact) => contact.type === pickedType);
  }

  setChannelOptions() {
    const options = this.props.channels
      .filter((channel) => {
        return channel.type === this.getPickedType();
      })
      .map((channel) => {
        return {
          label: channel.name,
          value: channel.id,
        };
      });

    if (options.length === 1) {
      this.setState({
        values: { ...this.state.values, channel: options[0].value },
        channelOptions: options,
      });
    } else {
      this.setState({ channelOptions: options });
    }
  }

  validateOption(input) {
    const type = this.getPickedType();
    const label = input.label;
    if (type === 'mailgun') {
      return validateEmailOption(label);
    }
    if (type === 'twilio') {
      return validateTelephoneOption(label);
    }
    return validateEmailOption(label) || validateTelephoneOption(label);
  }

  createNewOption(input) {
    // Overwrite default newOption handler so we can handle pasting comma seperated lists
    const inputs = input.value.split(',').map((val) => val.trim());
    const newTo = (this.state.values.to || []).concat(inputs);
    this.handleChange('to', newTo);
    // Clear the input box on the select component
    this.selectComp.select.setState({ inputValue: '' });
  }

  isOptionUnique({ option, options }) {
    const inputs = option.value.split(',').map((val) => val.trim());
    for (let index = 0; index < inputs.length; index++) {
      const input = inputs[index];
      const found = options.find(
        (opt) => opt.value === input || opt.email === input || opt.tel === input
      );
      if (!found) {
        return true;
      }
    }
    return false;
  }

  parseNewTos(newTos) {
    // For each new To's try and map them up to an actual option
    const mappedNewTos = newTos.map((to) => {
      if (to.type) {
        return to;
      } // if it has a type it's already matched
      const foundOption = this.state.toOptions.find(
        (opt) => opt.email === to || opt.tel === to
      );
      return (foundOption && foundOption.value) || to;
    });
    // Deduplicate the list
    return mappedNewTos.filter((to, index, mappedNewTos) => {
      if (mappedNewTos.indexOf(to) === index) {
        return true;
      }
      return false;
    });
  }

  refreshOptions(search) {
    this.setState({ searchString: search });
    if (this.state.searching) {
      return search;
    }
    if (search.length < 3) {
      this.setState({
        searching: false,
        loadingContacts: false,
      });
      return search;
    }
    this.setState({ loadingContacts: true, searching: true }, () => {
      setTimeout(() => {
        this.setState({ searching: false });
        this.getContacts({ search: this.state.searchString })
          .then((contacts) => {
            this.setState({
              toOptions: dedupe(
                this.state.toOptions.concat(this.getToOptions(contacts)),
                'value'
              ),
              contacts,
              loadingContacts: false,
            });
          })
          .catch((err) => {
            console.error(err);
            this.setState({ loadingContacts: false });
          });
      }, 750);
    });
    return search;
  }

  templateContext() {
    const context = [
      buildContactGroup(),
      buildAgentGroup(this.props.loggedInUser),
    ];
    if (this.state.values.channel) {
      const channel = this.props.channels.find(
        (channel) => channel.id === this.state.values.channel
      );

      if (channel) {
        context.push(
          buildSelectedChannelGroup({
            channel,
            showChannelQueuePosition: true,
          })
        );
      }
    }
    return context;
  }

  updateCC(newCC) {
    this.setState({ cc: newCC });
  }

  updateBCC(newBCC) {
    this.setState({ bcc: newBCC });
  }

  fields() {
    return [
      {
        label: 'To:',
        key: 'to',
        placeholder: 'Type to search or create new contact',
        required: true,
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI,
        options: this.state.toOptions,
        config: {
          isLoading: this.state.loadingContacts,
          noResultsText: `Enter an email address ${
            this.getPickedType() !== 'mailgun' ? `or phone number` : ''
          } to message a new contact.`,
          optionRenderer: (opt) => <OptionDisplay option={opt} />,
          valueRenderer: (opt) => <ValueDisplay option={opt} />,
          isValidNewOption: this.validateOption.bind(this),
          onNewOptionClick: this.createNewOption.bind(this),
          onInputChange: this.props.dontSelectExistingContacts
            ? (search) => search
            : this.refreshOptions.bind(this),
          isOptionUnique: this.isOptionUnique.bind(this),
          promptTextCreator: (label) => `Add "${label}"`,
          ref: (elem) => (this.selectComp = elem),
        },
      },
      {
        label: 'Channel:',
        key: 'channel',
        placeholder: 'Select a channel',
        required: true,
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: this.state.channelOptions,
        hideWhen: () => !this.state.values.to || !this.state.values.to.length,
      },
      {
        label: 'Assign Conversation To:',
        key: 'assign_to',
        placeholder: 'Select some Agents or Teams',
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <AgentTeamSelect />,
        hideWhen: () => {
          return (
            !this.state.values.to ||
            !this.state.values.to.length ||
            this.props.hideAssign
          );
        },
      },
      {
        label: 'Subject:',
        key: 'subject',
        required: true,
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        hideWhen: () => {
          return (
            this.getPickedType() !== 'mailgun' ||
            !this.state.values.to ||
            !this.state.values.to.length
          );
        },
      },
      {
        label: 'Message:',
        key: 'message',
        required: true,
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        helptext:
          'When using the Tag Builder the preview for Contact tags will display as a default contact.',
        component: (
          <ReplyBox
            availableChannels={[{ type: this.getPickedType() }]}
            editorMode={
              CONSTS.CHANNEL_CONTENT_TYPES[this.getPickedType()] ||
              CONSTS.EDITOR_MODE_TYPE.PLAIN
            }
            toolbarClassName={'compose-toolbar'}
            updateCallbacks={this.updateMessageCallbacks}
            editorState={this.state.values.messageEditorState}
            compileTemplateTags={false}
            templateContext={this.templateContext()}
            cc={this.state.cc}
            bcc={this.state.bcc}
            updateCC={this.updateCC.bind(this)}
            updateBCC={this.updateBCC.bind(this)}
            meta={{
              attachments: { show: true },
              saved_replies: { show: true },
              mail_merge: { show: true },
              mail_cc: {
                show:
                  this.getPickedType() === 'mailgun' &&
                  !this.props.hideCCOptions,
              },
              exclude_signature: {
                show:
                  this.getPickedType() === 'mailgun' &&
                  !this.props.hideSignatureOptions,
                excludeSignature: this.state.excludeSignature,
                onClick: () =>
                  this.setState({
                    excludeSignature: !this.state.excludeSignature,
                  }),
              },
            }}
          />
        ),
        hideWhen: () => {
          return !this.state.values.to || !this.state.values.to.length;
        },
      },
      {
        label: 'Transcript:',
        key: 'transcript',
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        helptext:
          'When using the Tag Builder the preview for Contact tags will display as a default contact.',
        component: (
          <ReplyBox
            availableChannels={[{ type: this.getPickedType() }]}
            editorMode={
              CONSTS.CHANNEL_CONTENT_TYPES[this.getPickedType()] ||
              CONSTS.EDITOR_MODE_TYPE.PLAIN
            }
            toolbarClassName={'compose-toolbar'}
            updateCallbacks={this.updateTranscriptCallbacks}
            editorState={this.state.values.transcriptEditorState}
            templateContext={this.templateContext()}
            meta={{
              saved_replies: { show: true },
              mail_merge: { show: true },
            }}
          />
        ),
        hideWhen: () => {
          return !this.state.values.to || !this.state.values.to.length;
        },
      },
    ];
  }

  handleChange(key, _newValue) {
    if (key === 'message' || key === 'transcript') {
      return;
    }
    if (key === 'to' && (!_newValue || !_newValue.length)) {
      // If the to field has been cleared reload the options
      if (!this.props.dontSelectExistingContacts) {
        this.setState({ loadingContacts: true });
      }
    }

    const newValue = key === 'to' ? this.parseNewTos(_newValue) : _newValue;
    const maxContacts = 20;
    if (key === 'to' && newValue.length > maxContacts) {
      new GeckoToastService().warning(
        `You can choose a maximum of ${maxContacts} Contacts when starting a new Conversation`
      );
      return;
    }

    const newValues = Object.assign({}, this.state.values, { [key]: newValue });
    this.setState({ values: newValues }, () => {
      if (key === 'to') {
        if (!this.props.dontSelectExistingContacts) {
          this.setState({ toOptions: this.getToOptions() });
        }
        this.setChannelOptions();
      }
    });
  }

  send() {
    if (!this.state.values.to || !this.state.values.to.length) {
      return new GeckoToastService().error('You need to pick some recipients');
    }
    if (!this.state.values.channel) {
      return new GeckoToastService().error(
        'You need to pick a channel to message the contacts through'
      );
    }
    if (this.getPickedType() === 'mailgun' && !this.state.values.subject) {
      return new GeckoToastService().error(
        'You need to add a subject for the email'
      );
    }
    const messageEditorState = this.state.values.messageEditorState;
    const transcriptEditorState = this.state.values.transcriptEditorState;
    const hasContent =
      messageEditorState &&
      messageEditorState.getCurrentContent().getPlainText().length > 0;
    const hasAttachments =
      this.state.values.attachments && this.state.values.attachments.length > 0;
    if (!hasContent && !hasAttachments) {
      return new GeckoToastService().error(
        'Please add a message to send to these contacts'
      );
    }
    if (RBfuncs.isTooLong(messageEditorState, { type: this.getPickedType() })) {
      return new GeckoToastService().error(
        'Messages on this channel can be no longer than 1600 characters'
      );
    }

    const toContactIds = this.state.values.to.map((selected) => {
      if (
        selected.indexOf('mailgun') !== -1 ||
        selected.indexOf('twilio') !== -1
      ) {
        return selected.split('_')[1];
      }
      // If it passes the email validate function it must be an email
      if (validateEmailOption(selected)) {
        return { type: 'mailgun', value: selected };
      }
      // If it passes the telephone validate function it must be a mobile number
      if (validateTelephoneOption(selected)) {
        return { type: 'twilio', value: selected };
      }
      return selected;
    });
    const message = {
      attachments: this.state.values.attachments,
      metadata: {
        excludeSignature: this.state.excludeSignature,
        cc: this.state.cc,
        bcc: this.state.bcc,
        subject: this.state.values.subject,
        transcript: convertToRaw(transcriptEditorState.getCurrentContent()),
      },
      editor_object: convertToRaw(messageEditorState.getCurrentContent()),
    };

    if (hasAttachments) {
      message.editor_object = convertToRaw(
        EditorState.createEmpty().getCurrentContent()
      );
    } else {
      message.content = messageEditorState.getCurrentContent().getPlainText();
    }

    if (this.props.sendFunction)
      return this.props.sendFunction(
        message,
        toContactIds,
        this.state.values.channel,
        this.state.values.assign_to
      );

    return new GeckoLoadingService()
      .resolve(
        GeckoRequest.post('/message/compose', {
          to: toContactIds,
          channel: this.state.values.channel,
          assign_to: this.state.values.assign_to,
          message: message,
        })
      )
      .then(() => {
        new GeckoToastService().success('Messages sent');
        new GeckoModalService().close();
      })
      .catch(renderError);
  }

  modalButtons = [
    {
      name: 'Send',
      preset: GECKO_CONSTS.BTN_PRESET_SAVE,
      icon: 'fas fa-paper-plane-top',
      handler: this.send.bind(this),
      disabledWhen: () => !this.state.values.to || !this.state.values.to.length,
    },
  ];

  render() {
    return (
      <GeckoModal
        name={this.props.title ? this.props.title : 'Compose a Message'}
        btns={this.modalButtons}
      >
        <div className="ComposeModal">
          <GeckoFields
            fields={this.fields()}
            values={this.state.values}
            handler={this.handleChange.bind(this)}
          />
        </div>
      </GeckoModal>
    );
  }
}

ComposeModal.defaultProps = {
  loggedInUser: {},
  channels: [],
  dontSelectExistingContacts: false,
};

const mapStateToProps = (state) => {
  return {
    myId: state.appState.loggedInUser.id,
    loggedInUser: state.appState.loggedInUser,
    channels: channelsForUsersTeams(state.channels).filter(
      (channel) => !channel.deletedAt
    ),
  };
};
export default connect(mapStateToProps)(ComposeModal);
